import ServiceChartWithImage from "./service_chart";

interface TopServiceProps {
    imageSrc: string;
    percentage: string;
    borderColor: string;
    backgroundColor: string;
    name: string;
    value: number;
    color: string;
}

export default function TopService({ imageSrc, percentage, borderColor, backgroundColor, name, value, color }: TopServiceProps) {
    return (
        <div className="w-fit flex flex-col items-center justify-center">
            <ServiceChartWithImage imageSrc={imageSrc} percentage={value} color={color} />

            <h1 className="text-white text-4xl font-bold">{percentage}</h1>
            <p className="text-white text-xs">of all sales</p>

            <div className={`w-fit bg-${name} text-white text-md rounded-lg px-2 py-1 my-3`}>{name}</div>
        </div>
    );
}